import * as React from 'react'
import * as styles from './HeaderMenuButton.css'

import { Plan } from '../../../../commons/Plan'
import InnerLink, { InnerLinkType } from '../../atoms/InnerLink/InnerLink'

interface HeaderMenuButtonProps {
  showMenu: () => void
  hideMenu: () => void
  isMenuShow: boolean
  plan: Plan
  handleLogOut: () => void
}

const HeaderMenuButton: React.FunctionComponent<HeaderMenuButtonProps> = ({
  showMenu,
  hideMenu,
  isMenuShow,
  plan,
  handleLogOut
}) => {
  const menuList = [
    <li className={styles.logout} key="header-menu-1">
      <InnerLink to="/password_reset/email" type={InnerLinkType.NORMAL}>
        パスワード変更
      </InnerLink>
    </li>,
    <li className={styles.logout} onClick={() => handleLogOut()} key="header-menu-2">
      <InnerLink to="/login" type={InnerLinkType.NORMAL}>
        ログアウト
      </InnerLink>
    </li>,
    <li className={styles.logout} key="header-menu-3">
      <InnerLink to="/withdraw" type={InnerLinkType.NORMAL}>
        退会
      </InnerLink>
    </li>
  ]

  return (
    <div className={styles.container}>
      <p className={styles.headerMenuButton} onClick={isMenuShow ? () => hideMenu() : () => showMenu()}>
        ︙
      </p>

      {isMenuShow ? (
        <div className={styles.headerMenu}>
          <ul>{menuList}</ul>
        </div>
      ) : null}
    </div>
  )
}

export default HeaderMenuButton
